import { Injectable, inject } from '@angular/core';
import { classes } from 'polytype';
import type { Observable } from 'rxjs';

import type {
    MonitoringDto,
    MonitoringFigureDto,
    MonitoringFigurePayload,
} from '@app/monitor/monitoring/monitoring.dto';
import { MONITORING_PATH } from '@app/shared/api/api-route.config';
import {
    type ItemResponse,
    type StatusResponse,
    WithCrudService,
} from '@app/shared/api/crud.service';
import { RestService } from '@app/shared/api/rest.service';
import { WithLogService } from '@app/shared/change-log/log.service';
import { WithJobService } from '@app/shared/job-history/job.service';
import { ToastNotificationService } from '@app/shared/notification/toast-notification.service';

@Injectable({
    providedIn: 'root',
})
export class MonitoringService extends classes(
    WithCrudService<MonitoringDto>,
    WithJobService,
    WithLogService,
) {
    protected endpoint = MONITORING_PATH;

    protected readonly api = inject(RestService);
    protected readonly toast = inject(ToastNotificationService);

    getStatsFigures(
        monitoringId: number,
        startDate: string | null,
        endDate: string | null,
    ): Observable<{ result: MonitoringFigureDto[] }> {
        return this.api.getWithParams(`${this.endpoint}${monitoringId}/stats/figures`, {
            startDate,
            endDate,
        });
    }

    saveStatsFigure(
        monitoringId: number,
        figure: MonitoringFigurePayload,
    ): Observable<ItemResponse<MonitoringFigureDto>> {
        return this.api.post(`${this.endpoint}${monitoringId}/stats/figure`, figure);
    }

    runStatsFigure(
        monitoringId: number,
        figureId: number,
        startDate: string | null,
        endDate: string | null,
    ): Observable<ItemResponse<MonitoringFigureDto>> {
        return this.api.getWithParams(`${this.endpoint}${monitoringId}/stats/figure/${figureId}`, {
            startDate,
            endDate,
        });
    }

    deleteStatsFigure(monitoringId: number, figureId: number): Observable<StatusResponse> {
        return this.api.delete(`${this.endpoint}${monitoringId}/stats/figure/${figureId}`);
    }
}
